import { Component } from '@angular/core';
import { OfferedService } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { NgControl, FormBuilder, Validators } from '@angular/forms';

export const offeredServiceFormConfig: FormConfig<OfferedService> = {
	id: [''],
	name: ['', Validators.required],
	type: ['', Validators.required],
	isActive: [true, Validators.required],
	railroad: [''],
};

@Component({
	selector: 'rpshared-offered-service',
	templateUrl: './offered-service.component.html',
})
export class OfferedServiceComponent extends CustomFormAccessor<OfferedService> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, offeredServiceFormConfig);
	}
}
